import axios, { type AxiosInstance } from 'axios';
import authenticationInterceptor from '@/api/interceptors/auth.interceptor';
import clientErrorInterceptor from './interceptors/error.interceptor';
import { type BaseApiCallOptions } from './httpHelper';

function create(config: BaseApiCallOptions = {
  baseURL: import.meta.env.VITE_API_GW_BASE_URL,
  timeout: import.meta.env.VITE_API_TIMEOUT_MS,
  timeoutErrorMessage: 'İstek zaman aşımına uğradı, lütfen tekrar deneyiniz.',
}) {
  const instance: AxiosInstance = axios.create({
    ...config,
  });
  authenticationInterceptor(instance);
  clientErrorInterceptor(instance);
  return instance;
}

const apiGwClient = create();
export default apiGwClient;
